import React, { FC, useState } from 'react';
import EmissionService from '../../../shared/services/emission';
import { ActionButton } from '@hdi-seguros/web-components.action-button';
import { ColSize, ContentSection, RowSize } from '../../../shared/components';
import { AlertComponent } from '../../../shared/components/AlertComponent';
import { displayErrorMessage } from '../../../shared/utils';

interface TransportsPageProps {
    title: string;
}

export const TransportsPage: FC<TransportsPageProps> = ({ title }) => {
    const [loading, setLoading] = useState(false);

    const handleOpenUrl = async () => {
        setLoading(true);
        try {
            const url = await EmissionService.postLambaVais();
            if (url) {
                window.open(url, '_blank');
            } else {
                displayErrorMessage('¡Ups, ocurrió un error! - VAIS: No se pudo obtener la URL.');
            }
        } catch (error) {
            displayErrorMessage('¡Ups, ocurrió un error! - VAIS: Error no controlado.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <ContentSection title={title} hasCard={false}>
            <RowSize rowProps={{ justify: 'center', align: 'middle' }}>
                <ColSize size={100}>
                    <AlertComponent
                        message={<b>Para esta cotización estarás saliendo de nuestro sitio web y serás redirigido a un sitio externo.</b>}
                        description="Si deseas continuar, presiona 'Aceptar'."
                        type='info'
                    />
                </ColSize>
                <ColSize size={100} className='confirmation-container-col'>
                    <ActionButton
                        className='btn-principal-barbuss '
                        label='Aceptar'
                        type="primary"
                        onClick={handleOpenUrl}
                        loading={loading}
                    />
                </ColSize>
            </RowSize>

        </ContentSection>
    );
};

export default TransportsPage;
